import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class M6ForecastDataService {
  private http = inject(HttpClient);

  private url = environment.url.bffV3;

  getM6ForecastData(timestamp: string): Observable<any> {
    const url = this.url + '/customer/m6/forecast/text/' + timestamp;
    return this.http.get(url);
  }

  getM6ForecastTrendData(days: number): Observable<any> {
    const url = this.url + '/customer/m6/forecast/trend/' + days;
    return this.http.get(url);
  }
}
